export default __webpack_public_path__ + "static/media/LostRfpInactiveLight.e3d02db6.svg";